import { faHeadset } from '@fortawesome/pro-regular-svg-icons';
import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { SolidButton } from './styles';
import { RailPromoCard } from './RailPromoCard';

export const Support = () => {
  const theme = useTheme();

  return (
    <RailPromoCard
      title="Support"
      icon={
        <FontAwesomeIcon
          icon={faHeadset}
          color={theme.palette.common.gunmetalBlue}
        />
      }
      description="You can look at some quick videos to get started with Cowbell Cyber Platform"
      action={
        <Link to="/customer/support" style={{ textDecoration: 'none' }}>
          <SolidButton sx={{ textTransform: 'none', letterSpacing: 0 }}>
            Get started
          </SolidButton>
        </Link>
      }
    />
  );
};
